export default __webpack_public_path__ + "static/media/season_5_mapfull.9a38f0e3.png";